import React from 'react'
import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react'
import { FooterType, ModalDefaultProps } from './interface'

const DefaultModal: React.FC<ModalDefaultProps> = ({
  title,
  contentMaxW,
  children,
  footerComponent,
  footerType = FooterType.INFO,
  onButtonCloseClick,
  onButtonCancelClick,
  onButtonSaveClick,
  isLoadingSave,
  hideFooter,
  ...props
}) => {
  return (
    <Modal {...props} isCentered closeOnOverlayClick={false}>
      <ModalOverlay />
      <ModalContent maxW={contentMaxW || '600px'}>
        {title && <ModalHeader>{title}</ModalHeader>}
        <ModalCloseButton />
        <ModalBody py={5}>{children}</ModalBody>
        {!hideFooter && (
          <ModalFooter display="flex" justifyContent="flex-end" gap={4}>
            {footerComponent ? (
              footerComponent
            ) : footerType === FooterType.FORM ? (
              <>
                <Button
                  variant=""
                  onClick={() => {
                    onButtonCancelClick && onButtonCancelClick()
                  }}
                >
                  Cancel
                </Button>
                <Button
                  onClick={() => {
                    onButtonSaveClick && onButtonSaveClick()
                  }}
                  isLoading={isLoadingSave}
                >
                  Save
                </Button>
              </>
            ) : (
              <Button
                colorScheme="blue"
                mr={3}
                onClick={() => {
                  onButtonCloseClick && onButtonCloseClick()
                }}
              >
                Close
              </Button>
            )}
          </ModalFooter>
        )}
      </ModalContent>
    </Modal>
  )
}

export default DefaultModal
